"use client";

import * as React from "react";

import { useIsMobile } from "@/hooks/use-mobile";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "@/components/ui/drawer";
import { LeadCaptureForm } from "@/components/lead-capture-form";

interface LeadCaptureModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LeadCaptureModal({
  open,
  onOpenChange,
}: LeadCaptureModalProps) {
  const isMobile = useIsMobile();

  const handleClose = () => onOpenChange(false);

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className="max-h-[90vh] px-2">
          <DrawerTitle className="sr-only">Book a Demo</DrawerTitle>
          <div className="overflow-y-auto p-4 pb-8">
            <LeadCaptureForm onClose={handleClose} />
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton
        className="max-h-[90vh] overflow-y-auto sm:max-w-[520px]"
      >
        <DialogTitle className="sr-only">Book a Demo</DialogTitle>
        <LeadCaptureForm onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
